import isEqual from 'react-fast-compare';

import {RESTWarehouseParameter} from 'insights/parameters/RESTParameterTypes';
import {RunQueryData} from 'insights/warehouse/AnalyticsWarehouseDAO';
import sortedBy from 'util/sortedBy';

function getComparableData(data: RunQueryData): RunQueryData {
  return {
    ...data,
    // Ignore order by sorting by parameter name (which should be a unique sort key)
    parameters: sortedBy(data.parameters, [
      (parameter: RESTWarehouseParameter) => parameter.config.systemName,
    ]),
  };
}

/**
 * Return if 2 RunQueryDatas are deep equal, ignoring parameter order
 *
 * RunQueryData {          <- check deep equality
 *   parameterizedSQLQuery
 *   parameters            <- ignore order
 * }
 */
export default function areRunQueryDatasEqual(left: RunQueryData, right: RunQueryData): boolean {
  return isEqual(getComparableData(left), getComparableData(right));
}
